// extracted by mini-css-extract-plugin
export default {"formContainer":"AddClient_formContainer__sC4j-","formField":"AddClient_formField__Da-8F","fullInput":"AddClient_fullInput__PoZZo","btnsContainer":"AddClient_btnsContainer__FSXpP"};